import * as Yup from "yup";
import { TParcelShippingMethod } from "@/types/parcel.types";

// Validation schemas for send-parcel steps (used in parcelSteps.tsx)
export const shipmentCreateSchema = Yup.object().shape({
  shippingMethod: Yup.string().required(),
});

export const senderInfoSchema = Yup.object().shape({
  senderFirstName: Yup.string().required("validations_first_name"),
  senderLastName: Yup.string().required("validations_last_name"),
  senderEmail: Yup.string().required("validations_email"),
  senderPhone: Yup.string().required("validations_phone"),
  senderAddress: Yup.string().required("validations_address"),
  senderCountry: Yup.object().shape({
    id: Yup.string().required("validations_country"),
    mainText: Yup.string().required("validations_country"),
  }),
  senderCity: Yup.object().shape({
    id: Yup.number().required("validations_city"),
    mainText: Yup.string().required("validations_city"),
  }),
});

export const shipmentDetailsSchema = Yup.object().shape({
  category: Yup.object()
    .shape({
      id: Yup.number().required("validations_category_required"),
      mainText: Yup.string().required("validations_category_required"),
    })
    .required("validations_category_required"),
  weight: Yup.string().required("validations_weight"),
  length: Yup.string().required("validations_length"),
  width: Yup.string().required("validations_width"),
  height: Yup.string().required("validations_height"),
  productPrice: Yup.string().required("validations_product_price_required"),
  country: Yup.object()
    .shape({
      id: Yup.number().required(),
      mainText: Yup.string().required("validations_country"),
    })
    .required("validations_country"),
});

export const receiverInfoSchema = Yup.object().shape({
  receiverCountry: Yup.lazy((value, context) => {
    if (context.parent.skipRecieverAddressInfo) {
      return Yup.object().nullable();
    }
    return Yup.object().shape({
      id: Yup.number().required("validations_country_or_skip"),
      mainText: Yup.string().required("validations_country_or_skip"),
    });
  }),
  receiverState: Yup.lazy((value, context) => {
    if (context.parent.skipRecieverAddressInfo) {
      return Yup.object().nullable();
    }
    return Yup.object().shape({
      id: Yup.number().required("validations_state_or_skip"),
      mainText: Yup.string().required("validations_state_or_skip"),
    });
  }),
  receiverAddress: Yup.lazy((value, context) => {
    if (context.parent.skipRecieverAddressInfo) {
      return Yup.object().nullable();
    }
    return Yup.string().required("validations_address_or_skip");
  }),
  receiverAddress2: Yup.string().nullable(),
  receiverZip: Yup.lazy((value, context) => {
    if (context.parent.skipRecieverAddressInfo) {
      return Yup.object().nullable();
    }
    return Yup.string().required("validations_zip_code_or_skip");
  }),
  receiverName: Yup.string().required(),
  receiverPhone: Yup.string().required(),
  receiverEmail: Yup.string().required(),
  skipRecieverAddressInfo: Yup.boolean(),
});

export const shippingOptionsSchema = Yup.object().shape({
  // delivery: Yup.object()
  //   .shape({
  //     id: Yup.number().required("validations_delivery_option"),
  //     title: Yup.string(),
  //     price: Yup.string().required("validations_price_required"),
  //   })
  //   .required("validations_delivery_option"),
  // services: Yup.array().of(
  //   Yup.object().shape({
  //     id: Yup.number(),
  //     title: Yup.string(),
  //     price: Yup.string(),
  //   }),
  // ),
});

export const parcelShippingMethodSchema: Yup.ObjectSchema<TParcelShippingMethod> =
  Yup.object().shape({
    shippingMethod: Yup.string()
      .oneOf(["get-parcel", "send-parcel"], "validations_shipping_method")
      .required("validations_shipping_method_required"),
  });

//@ts-ignore
export const parcelServicesSchema: Yup.ObjectSchema<TParcelServices> =
  Yup.object().shape({
    services: Yup.array().of(Yup.number()).default([]),
    servicePhotoOfContentsComment: Yup.string(),
    serviceFunctionalityCheckComment: Yup.string(),
    serviceDivideInformation: Yup.array()
      .of(
        Yup.object({
          priceUsd: Yup.number().when("$services", {
            is: (services) => services?.includes(1),
            then: (schema) => schema.required("validations_price_required"),
            otherwise: (schema) => schema.nullable(),
          }),
          description: Yup.string().when("$services", {
            is: (services) => services?.includes(1),
            then: (schema) =>
              schema.required("validations_description_required"),
            otherwise: (schema) => schema.nullable(),
          }),
          customAddressId: Yup.object({
            id: Yup.number(),
            mainText: Yup.string().nullable(),
          })
            .when("$services", {
              is: (services) => services?.includes(1),
              then: (schema) =>
                schema
                  .typeError("validations_field_required") // Ensure numeric type validation
                  .required("validations_field_required"),
              otherwise: (schema) => schema.nullable(),
            })
            .required("validations_custom_address_required"),
        }).required("validations_service_divide_info_required"),
      )
      .when("services", {
        is: (services) => services.includes(1),
        then: (schema) =>
          schema.required("validations_service_divide_info_required"),
        otherwise: (schema) => schema.nullable(),
      }),
  });
